import { render, staticRenderFns } from "./CallInformationManagement.vue?vue&type=template&id=05f9e95e&scoped=true"
import script from "./CallInformationManagement.vue?vue&type=script&lang=js"
export * from "./CallInformationManagement.vue?vue&type=script&lang=js"
import style0 from "./CallInformationManagement.vue?vue&type=style&index=0&id=05f9e95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f9e95e",
  null
  
)

export default component.exports